var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Any.js
// module id = 174
// module chunks = 114276838955818